import React, { useContext, useEffect, useState } from 'react';
import { TextField, CircularProgress, Autocomplete } from '@mui/material';

import DrawerContext from '../../../context/DrawerContext';
import AuthContext from '../../../context/AuthContext';
import CustomButton from '../../../common/CustomButton';


function AddCategory({ drawerDetails }) {

  const authCtx = useContext(AuthContext);
  const drawerCtx = useContext(DrawerContext);

  const [ categoryName, setCategoryName ] = useState("");
  const [ subcategoryName, setSubcategoryName ] = useState('');
  const [ subCategory, setSubCategory ] = useState('');
  const [ isSubCategorySelected, setIsSubCategorySelected ] = useState(false);
  const [ isMainCategorySelected, setIsMainCategorySelected ] = useState(false);
  const [ file, setFile ] = useState(null);
  const [ loading, setLoading ] = useState(false);
  const [ isSaving, setIsSaving ] = useState(false);
  const [ isMainCategoryChecked, setIsMainCategoryChecked ] = useState(false);
  const [ mainCategory, setMainCategory ] = React.useState('');
  const [ subcategories, setSubcategories ] = useState([]);
  const [ allCategories, setAllCategories ] = useState(drawerCtx.details.allCategories);
  const [ parentCategories, setParentCategories ] = useState(drawerCtx.details.parentCategories);
  const [ validationError, setValidationError ] = useState('');

  // console.log(allCategories);

  // Computed value for filtered subcategories that updates when mainCategory changes
  const getFilteredSubcategories = () => {
    const filtered = allCategories
      .filter(category => category.id !== mainCategory) // Exclude selected main category
      .filter(category => {
        // Only include subcategories (type !== 'main') that don't belong to the selected main category
        if (category.type === 'main') {
          return false; // Exclude all main categories
        } else {
          // For subcategories, exclude those that already belong to the selected main category
          return category.parentId !== mainCategory;
        }
      })
      .map((category) => category.title);
    
    // console.log('Main category selected:', mainCategory);
    // console.log('Filtered subcategories:', filtered);
    // console.log('All categories:', allCategories);
    
    return filtered;
  };

  // Clear subcategory when main category changes
  useEffect(() => {
    setSubCategory('');
    setIsSubCategorySelected(false);
  }, [mainCategory]);

  const createCategory = () => {

    setIsSaving(true);

    // Determine the main category data based on whether it was selected or typed
    let mainCategoryTitle;
    let mainCatSelectedId;
    let subcategoryData;
    
    if (isMainCategoryChecked) {
      // For main categories, check if it was selected from dropdown or typed
      if (isMainCategorySelected) {
        // Find the ID of the selected main category
        const selectedCategory = allCategories.find(cat => cat.title === categoryName.trim());
        mainCatSelectedId = selectedCategory ? selectedCategory.id : null;
        mainCategoryTitle = categoryName.trim();
        // console.log('Selected existing main category:', mainCatSelectedId, 'Title:', mainCategoryTitle);
      } else {
        // It's typed text - validate that it doesn't already exist as a main category
        const trimmedName = categoryName.trim();
        const existingMainCategory = parentCategories.find(cat => 
          cat.title.toLowerCase() === trimmedName.toLowerCase()
        );
        
        if (existingMainCategory) {
          console.error('Main category already exists:', trimmedName);
          setValidationError(`A main category with the name "${trimmedName}" already exists. Please choose a different name.`);
          setIsSaving(false);
          return;
        }
        
        mainCatSelectedId = null;
        mainCategoryTitle = trimmedName;
        // console.log('Creating new main category:', mainCategoryTitle);
      }
    } else {
      // For subcategories, check if it was selected from dropdown or typed
      if (isSubCategorySelected) {
        // Find the ID of the selected subcategory
        const selectedCategory = allCategories.find(cat => cat.title === subCategory.trim());
        subcategoryData = selectedCategory ? selectedCategory.id : subCategory.trim();
        // console.log('Selected existing subcategory:', subcategoryData, 'Title:', subCategory.trim());
      } else {
        // It's typed text, send as string
        subcategoryData = subCategory.trim();
        // console.log('Creating new subcategory:', subcategoryData);
      }
    }

    let payload = {
      isMainCat: isMainCategoryChecked,
      isMainCatSelected: isMainCategorySelected,
      isSubCatSelected: isSubCategorySelected,
      mainCategorySelected: mainCategory,
      mainCatSelectedId: mainCatSelectedId,
      subCategorySelected: subcategoryData,
      categoryTitle: mainCategoryTitle,
      subcategoryTitle: subcategoryData
    }

    console.log(payload);

    setIsSaving(false);

    try {
      fetch(`${process.env.REACT_APP_API_URI}/v3/admin/category`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + authCtx.token,
        },
        body: JSON.stringify(payload),
      })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        if (data.status === "success") {
          drawerCtx.setPageUpdate({page: "categories"});
          drawerCtx.closeDrawer();
          setIsSaving(false);
        } else {
          console.error("API Error:", data.message || "Unknown error occurred");
          setIsSaving(false);
        }
      })
      .catch((error) => {
        console.error("Network or API error:", error);
        setIsSaving(false);
      });
    } catch (error) {
      console.log("error : ", error);
      setIsSaving(false);
    }

  }

  const handleCheckboxChange = (e) => {
    if(!isMainCategoryChecked){
      setMainCategory("Main Category")
    }
    setIsMainCategoryChecked(e.target.checked);
    // Clear validation error when switching modes
    setValidationError('');
  };

  return (
    <div className="container">
      <div className="drawer">

        <header>
          <h1 style={{}} data-aos="fade-right" data-aos-delay="500">CREATE CATEGORY</h1>
        </header>

        <section className='add-category-content' >

          {/* <div className='icon-div'>
            <span>Icon:</span> <Avatar src={file ? drawerDetails.type.toLowerCase() == "edit" ? file : URL.createObjectURL(file):null} alt="Remy Sharp" sx={{ width: 100, height: 100 }} >{categoryName ? capitalize(categoryName[0]) : null}</Avatar>
            <input type="file" onChangeCapture={onFileChangeCapture}  />
          </div> */}

          <h3>Create a new <strong>Category</strong></h3><br/>
          
          <label htmlFor='maincatgory' className='maincatgory'>
            <input type="checkbox" id='maincatgory' checked={isMainCategoryChecked} onChange={handleCheckboxChange} />  Add as Top Level Category
          </label>
          <br/><br/>

            {
              !isMainCategoryChecked ? <Autocomplete
                key={parentCategories} // Force re-render when main category changes
                options={parentCategories}
                getOptionLabel={(option) => option.title}
                value={parentCategories.find(cat => cat.id === mainCategory) || null}
                onChange={(event, newValue) => {
                  setMainCategory(newValue ? newValue.id : '');
                }}
                filterOptions={(options, { inputValue }) => {
                  if (!inputValue) return options;
                  return options.filter((option) =>
                    option.title.toLowerCase().includes(inputValue.toLowerCase())
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Top Level Category"
                    placeholder="Search categories..."
                  />
                )}
                renderOption={(props, option) => (
                  <li {...props} key={option.id}>
                    {option.title}
                  </li>
                )}
                isOptionEqualToValue={(option, value) => option.id === value?.id}
                fullWidth
              /> : <>
                <Autocomplete
                  key={allCategories} // Force re-render when main category changes
                  freeSolo
                  options={allCategories.filter(category => category.type !== 'main').sort((a, b) => a.title.localeCompare(b.title)).map((category) => category.title)}
                  value={categoryName}
                  onChange={(event, newValue) => {
                    setCategoryName(newValue || '');
                    // Check if the newValue exists in the options (selected from dropdown)
                    const availableOptions = allCategories.filter(category => category.type !== 'main').sort((a, b) => a.title.localeCompare(b.title)).map((category) => category.title);
                    setIsMainCategorySelected(availableOptions.includes(newValue));
                  }}
                  onInputChange={(event, newInputValue) => {
                    setCategoryName(newInputValue);
                    // When typing, it's not a selection unless it matches an existing option
                    const availableOptions = allCategories.filter(category => category.type !== 'main').sort((a, b) => a.title.localeCompare(b.title)).map((category) => category.title);
                    setIsMainCategorySelected(availableOptions.includes(newInputValue));
                  }}
                  filterOptions={(options, { inputValue }) => {
                    if (!inputValue) return options;
                    return options.filter((option) =>
                      option.toLowerCase().includes(inputValue.toLowerCase())
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Top Level Category Title"
                      placeholder="Select existing category or type new name..."
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option}>
                      {option}
                    </li>
                  )}
                  isOptionEqualToValue={(option, value) => option === value}
                  fullWidth
                />
                 <p className='warning'>
                   <span>Warning:</span> New top level categories must be added to the mobile app during the build process.
                 </p>
                 {validationError && (
                   <p className='error' style={{ color: 'red', marginTop: '8px' }}>
                     <span>Error:</span> {validationError}
                   </p>
                 )}
               </>
            }
            <br/>
            {
              !isMainCategoryChecked && 
                <Autocomplete
                  key={getFilteredSubcategories()} // Force re-render when main category changes
                  freeSolo
                  options={getFilteredSubcategories()}  
                  value={subCategory}
                  onChange={(event, newValue) => {
                    setSubCategory(newValue || '');
                    // Check if the newValue exists in the options (selected from dropdown)
                    const availableOptions = getFilteredSubcategories();
                    setIsSubCategorySelected(availableOptions.includes(newValue));
                  }}
                  onInputChange={(event, newInputValue) => {
                    setSubCategory(newInputValue);
                    // When typing, it's not a selection unless it matches an existing option
                    const availableOptions = getFilteredSubcategories();
                    setIsSubCategorySelected(availableOptions.includes(newInputValue));
                  }}
                  filterOptions={(options, { inputValue }) => {
                    if (!inputValue) return options;
                    return options.filter((option) =>
                      option.toLowerCase().includes(inputValue.toLowerCase())
                    );
                  }}
                 renderInput={(params) => (
                   <TextField
                     {...params}
                     label="Sub Category Name"
                     placeholder="Select existing category or type new name..."
                   />
                 )}
                 renderOption={(props, option) => (
                   <li {...props} key={option}>
                     {option}
                   </li>
                 )}
                 isOptionEqualToValue={(option, value) => option === value}
                 fullWidth
               />
            }

        </section>

        <footer>
          <CustomButton onClick={() => drawerCtx.closeDrawer()} className="cancel">Cancel</CustomButton>
          <CustomButton onClick={() => createCategory()} variant="contained" disabled={ isSaving ||  (isMainCategoryChecked && !categoryName.trim()) || (!isMainCategoryChecked && (!mainCategory || !subCategory.trim())) }>
            {isSaving ? <CircularProgress style={{ color: "#fff" }} size={20} /> : "Create Category" }
          </CustomButton>
        </footer>

      </div>
    </div>
  );

}
export default AddCategory;

